import React from "react";
import styled from "styled-components";
import checkIcon from "../../../assets/images/icons/check-white.svg";
import breakpoints from "../../../styles/breakpoints";

const Button = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: black;
  margin-left: 10px;
  margin-right: 1px;
  padding: 9px 10px;
  border: 1px solid black;
  cursor: default;
  height: 35px;
  width: 45px;
  ${breakpoints.mdDown} {
    /* iPad and lower */
    height: 33px;
  }
`;

const CheckMarkImage = styled.img`
  height: 15px;
  width: 15px;
`;

const ButtonWithCheckMark = (props) => (
  <Button {...props}>
    <CheckMarkImage src={checkIcon} alt="Check Icon" />
  </Button>
);

export default ButtonWithCheckMark;
